
import React from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

const ErrorPage = () => {
  const history = useHistory();
  const location = useLocation();
  const redirectUrl = sessionStorage.getItem("redirectUrl") || "/";
  // console.log("redirectUrl",redirectUrl)
  const handleBack = () => {
    
    window.location.href = redirectUrl;

  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Oops! Something went wrong.</h2>
      <p style={styles.message}>
        The login link might be invalid or expired.
      </p>
      <button onClick={handleBack} style={styles.button}>
        Back to Login
      </button>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8f9fa",
  },
  title: {
    fontSize: "24px",
    marginBottom: "10px",
    color: "#dc3545",
  },
  message: {
    fontSize: "16px",
    marginBottom: "20px",
    color: "#555",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    border: "none",
    borderRadius: "4px",
    color: "#fff",
    cursor: "pointer",
  },
};

export default ErrorPage;
